<style scoped>
.asset-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
}

.asset-cards {
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;
}

.bold1 {
  font-weight: bold;
}

.actbtns {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.actbtn:hover {
  cursor: pointer;
  font-weight: bold;
}

.row:hover {
  background-color: var(--color-accent-extra);
  cursor: pointer;
}

.row-sel {
  background-color: var(--color-accent-extra);
  border: 1px solid var(--color-accent);
}

.profitText {
  font-size: 14px;
  text-align: right;
}

a:hover {
  text-decoration: underline;
}

.edit-api-key-icon {
  opacity: 0.7;
  cursor: pointer;
}

.edit-api-key-icon:hover {
  opacity: 1;
}

.boosterlist-table-cell {
  padding-left: 5px;
}

td {
  /*border: 1px solid mediumturquoise;*/
}

div {
  /*border: 1px solid mediumturquoise;*/
}

.order-icon {
  cursor: pointer;
  margin-top: 2px;
  fill: var(--color-text);
}
</style>
<template>
  <div>
    <FastbotAddExhangeModal @on-cancel="fbotdata.showAddExchangeModal = false" />
    <FastbotOrdersModal
      :show="ordersModalShow"
      :orders="fbotOrders"
      :asset="fbotAsset"
      @on-cancel="ordersModalShow = false"
    />
    <div
      class="newbox"
      style="text-align: right; font-size: 14px;"
    >
      <div style="display: flex; justify-content: flex-end; align-items: center">
        <div style="margin-right: auto; padding-right: 20px;">
          <div style="width: 250px; display: flex; justify-content: space-between">
            <RadioGroup
              style="min-width: 169px; text-align: left"
              v-model="fbotdata.type"
              type="button"
              size="small"
              @on-change="typeChanged"
            >
              <Radio
                label="ACT"
                style="font-size: 12px"
              >{{ $text.tr('АКТИВНЫЕ') }}</Radio>
              <Radio
                label="HIST"
                style="font-size: 12px"
              >{{ $text.tr('ИСТОРИЯ') }}</Radio>
            </RadioGroup>
            <div v-if="!(fbotdata.page === 0 && fbotdata.list.length < 10)">
              <Icon
                v-if="fbotdata.page > 0"
                size="23"
                style="cursor: pointer; margin-right: 10px"
                color="var(--color-neutral-light)"
                @click="changePage('back')"
                type="ios-arrow-back"
              />
              <Icon
                v-else
                size="23"
                style="margin-right: 10px"
                color="var(--color-neutral-dark)"
                type="ios-arrow-back"
              />
              <Icon
                v-if="!fbotdata.lastPage"
                size="23"
                style="cursor: pointer"
                color="var(--color-neutral-light)"
                @click="changePage('forward')"
                type="ios-arrow-forward"
              />
              <Icon
                v-else
                size="23"
                color="var(--color-neutral-dark)"
                type="ios-arrow-forward"
              />
            </div>
          </div>
        </div>
        <div
          v-if="fbotdata.exchTokenLoaded && fbotdata.exchTokenId !== ''"
          style="padding-right: 12px;"
        >
          <Icon
            size="30"
            color="var(--color-text-dark)"
            class="edit-api-key-icon"
            type="md-key"
            @click="showAddExchangeModal"
          />
        </div>
        <div style="padding-right: 30px; font-size: 13px; width: 130px;">
          <a
            :href="$text.tr('https://doc.capico.app/v/ru/features/booster')"
            target="_blank"
            style="color: var(--color-text-dark);"
          >
            {{ $text.tr('ИНСТРУКЦИЯ') }}
          </a>
        </div>
        <div>
          <Button
            size="small"
            long
            style="width: 130px;"
            @click="createNewFastbot"
          >
            <div>{{ $text.tr('НОВЫЙ') }}</div>
          </Button>
        </div>
      </div>
      <!--      <table width="100%" style="margin-bottom: 10px;">-->
      <!--        <tr>-->
      <!--          <td style="text-align: left">-->
      <!--            <RadioGroup v-model="fbotdata.type" type="button" size="small"  @on-change="typeChanged">-->
      <!--              <Radio label="ACT" style="font-size: 12px">АКТИВНЫЕ</Radio>-->
      <!--              <Radio label="HIST" style="font-size: 12px">ИСТОРИЯ</Radio>-->
      <!--            </RadioGroup>-->
      <!--            <div v-if="!(fbotdata.page === 0 && fbotdata.list.length < 10)" style="display: inline-block">-->
      <!--              <Icon v-if="fbotdata.page > 0" size="23" style="cursor: pointer; margin-left: 20px; margin-right: 10px" color="#cdcdcd" @click="changePage('back')" type="ios-arrow-back"/>-->
      <!--              <Icon v-else size="23" style="margin-left: 20px; margin-right: 10px" color="grey" type="ios-arrow-back"/>-->
      <!--              <Icon v-if="!fbotdata.lastPage" size="23" style="cursor: pointer" color="#cdcdcd" @click="changePage('forward')" type="ios-arrow-forward"/>-->
      <!--              <Icon v-else size="23" color="grey" type="ios-arrow-forward"/>-->
      <!--            </div>-->
      <!--          </td>-->
      <!--          <td v-if="fbotdata.exchTokenLoaded && fbotdata.exchTokenId !== ''" style="padding-right: 12px;">-->
      <!--              <Icon size="30" color="var(--color-text-dark)" class="edit-api-key-icon" type="md-key" @click="showAddExchangeModal"/>-->
      <!--          </td>-->
      <!--          <td style="padding-right: 30px; font-size: 13px; width: 130px;">-->
      <!--            <a href="https://capico.app/info/booster/" target="_blank" style="color: var(--color-text-dark);">-->
      <!--              ИНСТРУКЦИЯ-->
      <!--            </a>-->
      <!--          </td>-->
      <!--          <td style="width: 130px;">-->
      <!--            <Button size="small" long style="width: 100%;" @click="createNewFastbot">-->
      <!--              <div>НОВЫЙ</div>-->
      <!--            </Button>-->
      <!--          </td>-->
      <!--        </tr>-->
      <!--      </table>-->
      <div
        v-if="fbotdata.exchTokenLoaded && fbotdata.exchTokenId === ''"
        style="width: 100%; height: 95%; padding-bottom: 40px; font-size: 22px; display: flex; justify-content: center; align-items: center;"
      >
        <div style="text-align: left">
          <div style="border-bottom: 1px solid #6b74e7; padding-bottom: 5px">
            <span style="font-weight: bold; color: #6b74e7;">BOOSTER</span>
            {{ $text.tr('- уникальный продукт для Binance Futures') }}
          </div>
          <div style="margin-top: 20px;">
            <li>{{ $text.tr('минимум настроек') }}</li>
            <li>{{ $text.tr('управление двумя кнопками') }}</li>
            <li>{{ $text.tr('мгновенный переворот из лонга в шорт или обратно') }}</li>
            <li>{{ $text.tr('торговля с плечом до 20x') }}</li>
          </div>
        </div>
      </div>
      <table
        v-else
        style="text-align: left; border-collapse: collapse; width: 100%"
      >
        <tr style="font-weight: bold; font-size: 12px; color: var(--color-text-dark); height: 30px;">
          <td
            v-if="fbotdata.type === 'HIST'"
            style="padding-left: 5px"
          >{{ $text.tr('ОСТАНОВЛЕН') }}</td>
          <td
            v-else
            style="padding-left: 5px"
          >{{ $text.tr('СТАРТ') }}</td>
          <td class="boosterlist-table-cell">{{ $text.tr('АКТИВ') }}</td>
          <td class="boosterlist-table-cell">{{ $text.tr('НАПРАВЛЕНИЕ') }}</td>
          <td class="boosterlist-table-cell">{{ $text.tr('ПЛЕЧО') }}</td>
          <td class="boosterlist-table-cell">{{ $text.tr('ИНВЕСТИРОВАНО') }}</td>
          <td
            v-if="fbotdata.type === 'ACT'"
            style="text-align: right; padding-right: 5px"
          >{{ $text.tr('ТЕКУЩАЯ СДЕЛКА') }}</td>
          <td style="text-align: right; padding-right: 5px">{{ $text.tr('ОБЩИЙ РЕЗУЛЬТАТ') }}</td>
        </tr>
        <tr
          v-for="(fastbot, index) in fbotdata.list"
          @click="selectFastbot(index)"
          :key="fastbot.Id"
          style="font-size: 16px; height: 40px;"
          class="row"
          :class="{'row-sel': isSelected(fastbot.Id)}"
        >
          <td
            v-if="fbotdata.type === 'HIST'"
            style="padding-left: 10px"
          >{{ localTime(fastbot.Stopped) }}</td>
          <td
            v-else
            style="padding-left: 10px"
          >{{ localTime(fastbot.Created) }}</td>
          <td class="boosterlist-table-cell">
            <div class="asset-wrapper">
              <CoinIcon :symbol="fastbot.Asset" />
              <span>{{ fastbot.Asset }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                viewBox="0 0 33 30"
                class="order-icon"
                @click="getFastbotOrders(fastbot.Id, fastbot.Asset)"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.5 0H3H30H30.5C31.8807 0 33 1.11926 33 2.5C33 3.88074 31.8807 5 30.5 5H30H3H2.5C1.11926 5 0 3.88074 0 2.5C0 1.11926 1.11926 0 2.5 0ZM3 30H2.5C1.11926 30 0 28.8807 0 27.5C0 26.1193 1.11926 25 2.5 25H3H30H30.5C31.8807 25 33 26.1193 33 27.5C33 28.8807 31.8807 30 30.5 30H30H3ZM2.27271 17C1.01758 17 0 15.8807 0 14.5C0 13.1193 1.01758 12 2.27271 12H2.72729H27.2727H27.7273C28.9824 12 30 13.1193 30 14.5C30 15.8807 28.9824 17 27.7273 17H27.2727H2.72729H2.27271Z"
                />
              </svg>
            </div>
          </td>
          <td class="boosterlist-table-cell">
            <div
              v-if="fastbot.Stage === 'UP'"
              style="color: var(--color-success-light)"
            >{{ $text.tr('ВВЕРХ') }}</div>
            <div
              v-if="fastbot.Stage === 'DOWN'"
              style="color:var(--color-danger-light)"
            >{{ $text.tr('ВНИЗ') }}</div>
          </td>
          <td class="boosterlist-table-cell">{{ fastbot.Leverage }}X</td>
          <td class="boosterlist-table-cell" :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ parseFloat(fastbot.Amount).toFixed(2) }}</div></td>
          <td
            v-if="fbotdata.type === 'ACT'"
            style="text-align: right; padding-right: 5px"
          >
            <div
              v-if="parseFloat(returnProfitPctText(fastbot)) < 0"
              class="gred profitText"
            >
              <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ returnProfitQuoteText(fastbot) }}</div></div>
              <div>{{ returnProfitPctText(fastbot) }}</div>
            </div>
            <div
              v-else
              class="ggreen profitText"
            >
              <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ returnProfitQuoteText(fastbot) }}</div></div>
              <div>{{ returnProfitPctText(fastbot) }}</div>
            </div>
          </td>
          <td style="text-align: right; padding-right: 5px">
            <div
              v-if="parseFloat(returnRProfitPctText(fastbot)) < 0"
              class="gred profitText"
            >
              <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ returnRProfitText(fastbot) }}</div></div>
              <div>{{ returnRProfitPctText(fastbot) }}</div>
            </div>
            <div
              v-else
              class="ggreen profitText"
            >
              <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ returnRProfitText(fastbot) }}</div></div>
              <div>{{ returnRProfitPctText(fastbot) }}</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import CoinIcon from '@/components/common/CoinIcon.vue'
import { Component, Vue } from 'vue-property-decorator'
// @ts-ignore
import SlimApi from '@/util/slimapi'
import Util from '@/util/util'
import fastbot from '@/services/fastbot'
import { BotProfit, Fastbot, FastbotData, Smartlimit } from '@/util/types'
import FastbotOrdersModal from '@/components/MainPage/Fastbot/FastbotOrdersModal.vue'
import Decimal from 'decimal.js'
import FastbotAddExhangeModal from '@/components/MainPage/Fastbot/FastbotAddExhangeModal.vue'

@Component({
  components: {
    FastbotOrdersModal,
    FastbotAddExhangeModal,
    CoinIcon
  }
})
export default class FastbotList extends Vue {
  ordersModalShow = false
  fbotOrders: Smartlimit[] = []
  fbotAsset = ''

  get fbotdata () {
    // @ts-ignore
    return (this.$store.state.fastbot as FastbotData)
  }

  showAddExchangeModal () {
    this.fbotdata.showAddExchangeModal = true
  }

  localTime (utctime: string) {
    return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
  }

  changePage (direction: string) {
    if (direction === 'forward') {
      this.fbotdata.page += 1
    } else {
      if (this.fbotdata.page === 0) {
        // console.log('change page: ', direction, this.fbotdata.page)
        return
      }
      this.fbotdata.lastPage = false
      this.fbotdata.page -= 1
    }
    fastbot.updateList()
    // console.log('change page: ', direction, this.fbotdata.page)
  }

  returnProfitPctText (bot: Fastbot) {
    if (bot.Status === 'ACT') {
      if (bot.CurProfit !== undefined) {
        return bot.CurProfit.Pct + '%'
      }
    } else {
      if (bot.Profit !== undefined) {
        return bot.Profit.Pct + '%'
      }
    }
    return ''
  }

  returnProfitQuoteText (bot: Fastbot) {
    if (bot.Status === 'ACT') {
      if (bot.CurProfit !== undefined) {
        return bot.CurProfit.Usd + ' USDT'
      }
    } else {
      if (bot.Profit !== undefined) {
        return new Decimal(bot.Profit.Quote).toDP(2).toString() + ' USDT'
      }
    }
    return ''
  }

  returnRProfitText (bot: Fastbot) {
    if (bot.Profit) {
      return new Decimal(bot.Profit.Usd).toDP(2).toString() + ' USDT'
    }
    // return '0 USDT'
    return ''
  }

  returnRProfitPctText (bot: Fastbot) {
    if (bot.Profit) {
      return bot.Profit.Pct + '%'
    }
    // return '0%'
    return ''
  }

  createNewFastbot () {
    this.fbotdata.selected = undefined
    fastbot.getFastbotExcOrders()
  }

  isSelected (fbotId: string): boolean {
    if (this.fbotdata.selected) {
      return fbotId === this.fbotdata.selected.Id
    } else {
      return false
    }
  }

  selectFastbot (i: number) {
    this.fbotdata.selected = this.fbotdata.list[i]
    this.fbotdata.asset = this.fbotdata.list[i].Asset
    fastbot.getFastbotExcOrders()
  }

  getFastbotOrders (fbotId: string, asset: string) {
    const params = {
      params: {
        // @ts-ignore
        token: this.$store.state.sys.token,
        etid: this.fbotdata.exchTokenId,
        fbot_id: fbotId
      }
    }
    const ref = this
    SlimApi.get('fastbot/orders', params)
      .then((response: any) => {
        // console.log('getFastbotOrders:', response.data)
        if (response.data !== null) {
          if (!response.data.err) {
            // ok
            ref.fbotOrders = response.data
            ref.fbotAsset = asset
            ref.ordersModalShow = true
          } else {
            // error
            // @ts-ignore
            ref.$Notice.error({
              // @ts-ignore
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
        } else {
          // @ts-ignore
          ref.$Notice.info({
            // @ts-ignore
            title: ref.$text.tr('нет ордеров'),
            duration: 1
          })
        }
      }).catch((error: any) => {
        // error
        console.log(error)
        // @ts-ignore
        ref.$Notice.error({
          // @ts-ignore
          title: ref.$text.tr('Ошибка'),
          desc: Util.returnTextForErr(error),
          duration: 10
        })
      })
  }

  typeChanged () {
    this.fbotdata.page = 0
    this.fbotdata.lastPage = false
    fastbot.updateList()
  }

  mounted () {
    fastbot.updateList()
    setInterval(() => {
      fastbot.updateList()
    }, 2000)
  }
}
</script>
